import { useState, useEffect } from 'react';

const useFetch = (fetchFn, defaultValue) => {
    const [data, setData] = useState(defaultValue);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchFn()
            .then(result => setData(result))
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    return { data, loading };
};

export default useFetch;
